// removed by extract-text-webpack-plugin
module.exports = {"widget-templ-wrapper":"_2k_BM7GAWbav5U7-q3nBD1_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f06a68e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/dashboard/components/frame/DashboardWidgetList.vue
// module id = s/GO
// module chunks = 75